module.exports = __webpack_public_path__ + "static/6-292516ae2f944d9929e118fa7feed96e.svg";